module.exports = __webpack_public_path__ + "img/newbg.7b01bff6.png";